{
  "page": {
    "title": "Revenue",
    "description": "What SIB earned across the book: the savings share and the fees together"
  },
  "periods": {
    "label": "Revenue period",
    "allTime": "All time",
    "thisMonth": "This month",
    "thisQuarter": "This quarter",
    "thisYear": "This year",
    "selectRange": "Select range",
    "rangeRequired": "Choose a start and end date."
  },
  "toggles": {
    "label": "Revenue filters",
    "billingWithoutContract": "+ Billing without a contract",
    "allIdentifiedSavings": "+ All identified savings",
    "projectedRevenue": "+ Projected revenue",
    "tooltips": {
      "billingWithoutContract": "Include revenue that is not backed by a synced SIB contract.",
      "allIdentifiedSavings": "Include expected savings from spend that has not yet passed initial validation.",
      "projectedRevenue": "Include fee periods and savings shares scheduled more than a week before their billing date."
    }
  },
  "summary": {
    "total": "Total",
    "savingsShare": "Savings share",
    "fees": "Fees",
    "error": "Totals could not be loaded."
  },
  "view": {
    "label": "Revenue display",
    "spendCategory": "Display by spend category & service",
    "organization": "Display by organization"
  },
  "breakdown": {
    "title": "Revenue breakdown"
  },
  "billing": {
    "title": "Billing"
  },
  "table": {
    "columns": {
      "spendCategory": "Spend category / service",
      "organization": "Organization",
      "type": "Type",
      "billing": "Billing",
      "expected": "Expected",
      "earned": "Earned",
      "savingsShare": "Savings share",
      "fees": "Fees",
      "total": "Total"
    },
    "revenueType": {
      "savings_share": "Savings share",
      "fee": "Fee"
    },
    "unnamed": "Unassigned",
    "noData": {
      "title": "No revenue rows",
      "description": "No revenue rows match the current filters.",
      "errorTitle": "Revenue could not be loaded",
      "errorDescription": "Try again in a moment."
    }
  },
  "organization": {
    "title": "Revenue",
    "description": "What SIB earned from this organization: the savings share and the fees together",
    "kpis": {
      "totalRevenue": "Total revenue",
      "expectedRevenue": "Expected revenue",
      "estimatedTcv": "Estimated TCV",
      "savingsShare": "Savings share",
      "fees": "Fees",
      "savingsValidatedSpend": "Savings, validated spend",
      "savingsAllSpend": "Savings, all spend"
    },
    "table": {
      "columns": {
        "earnedOn": "Earned on",
        "type": "Type",
        "period": "Period",
        "serviceBilling": "Service Billing / VSR Report",
        "invoice": "Invoice",
        "expected": "Expected",
        "earned": "Earned"
      }
    }
  }
}
